// src/components/Modal/ConfirmCancelModal.js

import axios from "axios";
import { useEffect, useState } from "react";

function ConfirmCancelModal({ show, onClose, onConfirm, userType,cancel_status,refundEligible = true  }) {
  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState("");



  
 
  const [customReason, setCustomReason] = useState("");
  const [reasonsList, setReasonsList] = useState([]);
  const [loadingReasons, setLoadingReasons] = useState(false);
  const token = localStorage.getItem("authToken");
  const API_BASE = process.env.REACT_APP_API_BASE;

  // ✅ Fetch reasons from API
  useEffect(() => {
    if (show && showReason) {
      fetchReasons();
    }
  }, [show, showReason]);

  if (!show) return null;

 
const fetchReasons = async () => {
    try {
      setLoadingReasons(true);
      const res = await axios.get(`${API_BASE}/get-cancel-booking-reasons`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.status && Array.isArray(res.data?.data)) {
        setReasonsList(res.data.data);
      } else {
        setReasonsList([]);
      }
    } catch (err) {
      console.error("Error fetching cancel reasons:", err);
      setReasonsList([]);
    } finally {
      setLoadingReasons(false);
    }
  };

  const handleYesClick = () => {
    // If host (userType 2) clicks "Yes" first time, show reason input
    if (userType === 2 && cancel_status === null && !showReason) {
      setShowReason(true);
      return;
    }

    // If not host OR host already gave reason
    if (showReason && userType === 2) {
      const finalReason = reason === "Other" ? customReason.trim() : reason;
      onConfirm(finalReason);
      // onConfirm(reason);
    } else {
      onConfirm(); // For normal users
    }
  };

  return (
    <div className={`cancel-overlay  ${!showReason ? '' : 'tes_noo_part'}`}>
      <div className="cancel-modal">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>

        {!showReason ? (
          <>
            <p className="cancel-text">
              {/* Are you sure you want to cancel this booking? */}
              {!refundEligible
                ? "Are you sure you want to cancel the booking? You will not receive a refund."
                : "Are you sure you want to cancel this booking?"}
            </p>
            <div className="cancel-buttons">
             
              <button className="btn-yes" onClick={handleYesClick}>
                Yes
              </button>
               <button className="btn-no" onClick={onClose}>
                No
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="cancel-text">Please provide your reason for cancellation:</p>
              {loadingReasons ? (
              <p>Loading reasons...</p>
            ) : (
              <div className="choose_liststs">
                <ul>
                  {reasonsList.map((item) => (
                    <li className="bothsredoibtn" key={item.id}>
                      <label className="label--radio rft">
                        <span className="diss">{item.reason}</span>
                        <input
                          className="radio"
                          type="radio"
                          value={item.reason}
                          name="cancelReason"
                          checked={reason === item.reason}
                          onChange={(e) => setReason(e.target.value)}
                        />
                      </label>
                    </li>
                  ))}

                  {/* ✅ Add "Other" option */}
                  <li className="bothsredoibtn">
                    <label className="label--radio rft">
                      <span className="diss">Other</span>
                      <input
                        className="radio"
                        type="radio"
                        value="Other"
                        name="cancelReason"
                        checked={reason === "Other"}
                        onChange={(e) => setReason(e.target.value)}
                      />
                    </label>

                    {/* ✅ Show input when 'Other' selected */}
                    {reason === "Other" && (
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="Please specify your reason"
                        value={customReason}
                        onChange={(e) => setCustomReason(e.target.value)}
                      />
                    )}
                  </li>
                </ul>
              </div>
            )}
            <div className="cancel-buttons">
              {/* <button className="btn-no" onClick={onClose}>
                Cancel
              </button> */}
              <button
                className="btn-yes"
                onClick={handleYesClick}
                disabled={!reason.trim()}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ConfirmCancelModal;
